export enum AvatarSize {
  Small = 'small',
  Tiny = 'tiny',
}
